// translations/pages/team/ja.js
// Texts of the team overview and of the navigation inside a profile. The
// profiles themselves come from src/profile (one folder per member).
export const teamPageJA = {
  hero: {
    title: 'チーム',
    intro: 'Adrian EisenmeierとNikolai Genovは、pAIoneer Labs GmbHを創業し、代表取締役として経営しています。',
    members: 'Adrian Eisenmeierはディプロム物理学者で、AI、ソフトウェアアーキテクチャ、データ保護、セキュリティが交わる領域でシステムを開発しています。Nikolai Genovはバイオインフォマティクスの博士号を持ち、規制の厳しいヘルスケア、ライフサイエンス、金融の各分野で、AI支援ソフトウェア開発とアナリティクスのテクニカルリードを務めています。Alina Tselininaは金融数学・保険数理の修士号を持つソフトウェア開発者兼データエンジニアで、PythonとRでアプリケーション、REST API、データパイプラインを開発しています。'
  },
  card: {
    cta: 'プロフィールを見る'
  },
  profile: {
    overview: 'チーム',
    membersLabel: 'チームメンバー'
  }
};
